export const ExportJObCols = (feature: boolean) => {
    return [{
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'exportJobNumber',
        isActionLink: true,
        id: 'exportJobNumber-col-link',
        fieldHeader: 'Document number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: feature,
        accessor: 'productType',
        id: 'productType-col',
        fieldHeader: 'Product Type',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'exportJobStatus',
        id: 'exportJobfinOpsStatus-col',
        fieldHeader: 'FinOps Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'primaryDocumentStatus',
        id: 'exportJobStatus-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'cblStatus',
        id: 'exportJobCblStatus-col',
        fieldHeader: 'CBL Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'cblNumber',
        id: 'exportJobCblNumber-col',
        fieldHeader: 'CBL Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sapSalesOrderNumber',
        id: 'exportJobSapsoNumber-col',
        fieldHeader: 'SAP SO Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'source',
        id: 'exportJobSource-col',
        fieldHeader: 'Source',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'salesOrg',
        id: 'exportJobSalesOrg-col',
        fieldHeader: 'Sales Organization',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'origin',
        id: 'exportJobOrigin-col',
        fieldHeader: 'Origin / Destination Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consignee',
        id: 'exportJobConsignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipper',
        id: 'exportJobShipper-col',
        fieldHeader: 'Shipper',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'contractualParty',
        id: 'exportJobContractualParty-col',
        fieldHeader: 'Contractual Party',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'jobCreationDate',
        id: 'exportJobCreationDate-col',
        fieldHeader: 'Job Creation Date',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'estimatedTimeOfDeparture',
        id: 'exportJobEtd-col',
        fieldHeader: 'ETD',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'estimatedTimeOfArrival',
        id: 'exportJobEta-col',
        fieldHeader: 'ETA',
        sortable: true,
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'exportJobLastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'exportJobLastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: false,
        accessor: 'exportJobId',
        id: 'exportJobId',
        fieldHeader: 'Export Job Id',
        sortable: false
    },
    {
        headerClassName: 'data-table header no-sorting',
        show: true,
        accessor: 'agedTime',
        id: 'agedInHrs',
        fieldHeader: 'Aging (Hours)',
        sortable: false
    },
    {
        headerClassName: 'data-table header no-sorting',
        show: true,
        className: 'overflowVisible',
        accessor: 'rateErrorMessage',
        id: 'errorMessage',
        fieldHeader: 'Error Message',
        sortable: false
    }];
}
